import { createSlice } from "@reduxjs/toolkit";

interface IBookButtonState {
  loading: boolean;
}

const initialState: IBookButtonState = {
  loading: false,
};

const bookButtonSlice = createSlice({
  name: "bookButton",
  initialState,
  reducers: {
    setBookButtonLoading(state, action) {
      state.loading = action.payload;
    },
    startBookButtonLoading(state) {
      state.loading = true;
    },
    stopBookButtonLoading(state) {
      state.loading = false;
    },
  },
});

export const {
  setBookButtonLoading,
  startBookButtonLoading,
  stopBookButtonLoading,
} = bookButtonSlice.actions;

export default bookButtonSlice.reducer;